import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const ITEM_CLASS = "-mx-3 block px-3 py-2 font-semibold leading-7 lg:text-center lg:text-lg xl:text-xl";
const IDLE_CLASS = "text-blue-500 dark:text-[#cccccc]";
const ACTIVE_CLASS = "text-blue-700 dark:text-blue-300";

/** Пункт шапки: прямая ссылка (to) или подменю (links: [{ to, label }]). */
function NavItem({ name, to, links = [] }) {
  const [isOpen, setIsOpen] = useState(false);

  if (to) {
    return (
      <div className="relative px-2 xl:px-3">
        <NavLink
          to={to}
          className={({ isActive }) => `${ITEM_CLASS} whitespace-nowrap ${isActive ? ACTIVE_CLASS : IDLE_CLASS}`}
        >
          {name}
        </NavLink>
      </div>
    );
  }

  return (
    <div
      className="relative px-2 xl:px-3"
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <div className="flex items-center justify-center">
        <button
          className={`${ITEM_CLASS} whitespace-nowrap ${isOpen ? ACTIVE_CLASS : IDLE_CLASS}`}
          type="button"
          aria-expanded={isOpen}
          onClick={() => setIsOpen(true)}
        >
          {name}
        </button>
      </div>
      {isOpen && (
        <div className="born-item absolute right-0 top-full z-10 flex flex-col rounded-lg bg-gray-200 px-4 py-2 dark:bg-zinc-900">
          {links.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={true}
              className="nav-link whitespace-nowrap"
              onClick={() => setIsOpen(false)}
            >
              {link.label}
            </NavLink>
          ))}
        </div>
      )}
    </div>
  );
}

export default NavItem;
